import Drawer from 'react-modern-drawer';
import Descriptions from '@uiw/react-descriptions';
import Switch from 'react-switch';
import './skuLine.scss';

function SkuDrawer({ sku, showDesc, setShowDesc }) {
  return (
    <div>
      <Drawer
        open={showDesc}
        onClose={() => setShowDesc(false)}
        direction="right"
        size={'40vw'}
        style={{
          zIndex: '10000',
          overflowX: 'hidden',
          overflowY: 'scroll',
          paddingBottom: '10vh'
        }}
      >
        <div className="p-3">
          <div className="row">
            <div className="col align-self-start">Sku Details</div>
            <div className="col align-self-end text-right" role={'button'}>
              <i
                className="feather icon-x-circle ml-2 mt-2"
                style={{ fontSize: '150%', color: 'red' }}
                onClick={() => setShowDesc(!showDesc)}
              />
            </div>
          </div>
        </div>
        <div className="p-3 sku--descp">
          <Descriptions bordered colon={false}>
            <Descriptions.Item label="Sku #" span={3}>
              {sku.No}
            </Descriptions.Item>
            <Descriptions.Item label="Last Date Modified" span={3}>
              {sku.Last_Date_Modified}
            </Descriptions.Item>
            <Descriptions.Item label="Tariff #" span={3}>
              {sku.Tariff_No}
            </Descriptions.Item>
            <Descriptions.Item label="Type" span={3}>
              {sku.Type}
            </Descriptions.Item>
            <Descriptions.Item label="Status " span={3}>
              {sku.Approval_Status_BETT}
            </Descriptions.Item>
            <Descriptions.Item label="Base Unit" span={3}>
              {sku.Base_Unit_of_Measure}
            </Descriptions.Item>
            <Descriptions.Item label="Flushing Method" span={3}>
              {sku.Flushing_Method}
            </Descriptions.Item>
            <Descriptions.Item label="Prod Group" span={3}>
              {sku.Gen_Prod_Posting_Group}
            </Descriptions.Item>
            <Descriptions.Item label="Inventory Posting" span={3}>
              {sku.Inventory_Posting_Group}
            </Descriptions.Item>
            <Descriptions.Item label="Manufacturing Policy" span={3}>
              {sku.Manufacturing_Policy}
            </Descriptions.Item>
            <Descriptions.Item label="Description" span={3}>
              {sku.Description}
            </Descriptions.Item>
            <Descriptions.Item label="Unit Cost" span={3}>
              {sku.Unit_Cost}€
            </Descriptions.Item>
            <Descriptions.Item label="Standard Cost" span={3}>
              {sku.Standard_Cost}€
            </Descriptions.Item>
            <Descriptions.Item label="Overhead Rate" span={3}>
              {sku.Overhead_Rate}
            </Descriptions.Item>
            <Descriptions.Item label="Indirect Cost Percent" span={3}>
              {sku.Indirect_Cost_Percent}%
            </Descriptions.Item>
            <Descriptions.Item label="Profit_Percent" span={3}>
              {sku.Profit_Percent}%
            </Descriptions.Item>
            <Descriptions.Item label="Assembly BOM" span={3}>
              <Switch checked={sku.Assembly_BOM || false} disabled onChange={() => {}} />
            </Descriptions.Item>
            <Descriptions.Item label="Blocked" span={3}>
              <Switch checked={sku.Blocked || false} disabled onChange={() => {}} />
            </Descriptions.Item>
            <Descriptions.Item label="Cost is Adjusted" span={3}>
              <Switch checked={sku.Cost_is_Adjusted || false} disabled onChange={() => {}} />
            </Descriptions.Item>
            <Descriptions.Item label="Coupled to CRM" span={3}>
              <Switch checked={sku.Coupled_to_CRM || false} disabled onChange={() => {}} />
            </Descriptions.Item>
            <Descriptions.Item label="Created From Nonstock Item" span={3}>
              <Switch
                checked={sku.Created_From_Nonstock_Item || false}
                disabled
                onChange={() => {}}
              />
            </Descriptions.Item>
            <Descriptions.Item label="STK BETT" span={3}>
              <Switch checked={sku.STK_BETT || false} disabled onChange={() => {}} />
            </Descriptions.Item>
            <Descriptions.Item label="Stockkeeping Unit Exists" span={3}>
              <Switch
                checked={sku.Stockkeeping_Unit_Exists || false}
                disabled
                onChange={() => {}}
              />
            </Descriptions.Item>
            <Descriptions.Item label="Substitutes Exist" span={3}>
              <Switch checked={sku.Substitutes_Exist || false} disabled onChange={() => {}} />
            </Descriptions.Item>
          </Descriptions>
        </div>
      </Drawer>
    </div>
  );
}

export default SkuDrawer;
